export const blueprintsSuggestionsDictionary = {
  space: "space",
  name: "name",
  updatedAt: "updated at",
  slug: "ID",
} as { [key: string]: string };

export const sortItemOrder = ["name", "space", "updatedAt"];

export const EXCLUDED_FILTER_FIELDS = ["timestamp"];
